import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { UserList } from '../users/UsersList';
import { UsersStateProvider } from '../providers/usersProvider';

export function UsersListPage() {

  return (
    <>
      <UsersStateProvider />
      <FloatingCardsLayout
        listSize={720}
        list={<UserList />}
      />
    </>
  );
}
